module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-setting"
  }, [(_vm.initing) ? _c('Spin', {
    attrs: {
      "fix": "",
      "size": "large"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "setting-row with-separator"
  }, [_c('label', [_vm._v("缓存技术：")]), _vm._v(" "), _c('iSwitch', {
    attrs: {
      "size": "large",
      "disabled": _vm.disabledCacheSetting
    },
    model: {
      value: (_vm.useCache),
      callback: function($$v) {
        _vm.useCache = $$v
      },
      expression: "useCache"
    }
  }, [_c('span', {
    slot: "open"
  }, [_vm._v("开")]), _vm._v(" "), _c('span', {
    slot: "close"
  }, [_vm._v("关")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "setting-row"
  }, [_c('Button', {
    staticClass: "save-btn",
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.saveSetting()
      }
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "保存成功"
    },
    on: {
      "on-ok": function($event) {
        _vm.reloadPage()
      }
    },
    model: {
      value: (_vm.saveSuccessed),
      callback: function($$v) {
        _vm.saveSuccessed = $$v
      },
      expression: "saveSuccessed"
    }
  }, [_c('p', [_vm._v("保存成功，刷新后立刻生效，是否刷新页面？")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4801176c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/setting/setting.vue
// module id = 974
// module chunks = 0